
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 2.703A9 9 0 0110.5 19.5v1c5.523 0 10-4.477 10-10A9.998 9.998 0 0015.771 2H19V1h-5v5h1V2.703zM5 17.625A9 9 0 0110.5 1.5v-1C4.977.5.5 4.977.5 10.5A9.983 9.983 0 003.885 18H1v1h5v-5H5v3.625z"}})])
          )
        }
      }
    